module.exports = __webpack_public_path__ + "7e4b29ba/img/trash-icon.ff8201c7.svg";